import I18n from "shared/i18n"
import useCurrentCountry from "components/utils/use-current-country"

const usaCountryCode = "US"

const dateFormatsByCountryCode = {
  US: {
    "date": "%Y-%m-%d",
    "date-long": "%Y-%m-%d",
    "date-with-weekday": "%Y-%m-%d",
    "time": "%H:%M",
    "date-with-time": "%Y-%m-%d %H:%M"
  },
  default: {
    "date": "%d-%m-%y",
    "date-long": "%A d. %e. %B",
    "date-with-weekday": "%A d. %e. %B",
    "time": "%H:%M",
    "date-with-time": "%d-%m-%y %H:%M"
  }
}

/** Date formatting helpers based on the currently selected country. */
function useDates() {
  const currentCountry = useCurrentCountry()
  const countryCode = currentCountry?.countryCode() == usaCountryCode ? usaCountryCode : "default"

  /**
   * Formats a date according to selected country.
   * @param {Date} date
   * @param {string} format
   * @returns {string}
   */
  function l(date, format = "date") {
    if (!date) return ""

    const countryFormats = dateFormatsByCountryCode[countryCode]
    const parsedFormat = countryFormats[format] || format

    return I18n.strftime(parsedFormat, date)
  }

  return {l}
}

export default useDates
